import licenseModule from '../../license.module';
import $ from 'jquery';

export default licenseModule.component('licenseRegisterNewInstance', {
    template: require('./licenseRegisterNewInstance.component.html'),
    controller: [
        'LicenseManagementService',
        licenseRegisterNewInstanceComponent
    ],
    bindings: {
        resolve: '<',
        dismiss: '&',
        close: '&'
    }
});

function licenseRegisterNewInstanceComponent(LicenseManagementService) {
    var vm = this;
    vm.processing = false;
    vm.showLoading = true;

    vm.$onInit = function() {
        vm.resolve.data = {
            serverProfile: {
                details: []
            }
        };
        LicenseManagementService.getAppspaceIDSummary().then(function(data) {
            vm.summary = data;
            vm.navs = getNavigation();
            vm.currentWorkflow = vm.navs[0];
            vm.showLoading = false;
        });
        vm.license = {
            server: {
                payload: '',
                name: '',
                description: '',
                countryCode: '',
                profiles: []
            },
            subscription: {
                maxUsers: 0,
                maxDevices: 0
            },
            perpetual: {
                maxUsers: 0,
                maxDevices: 0
            },
            eula: false,
            payload: '',
            serverProfileError: false,
            hideButton: false
        };
    };

    vm.getDisabled = function() {
        if (vm.currentWorkflow != undefined) {
            if (vm.currentWorkflow.value == 'server') {
                return (
                    vm.license.eula == false ||
                    vm.license.server.payload == '' ||
                    vm.license.serverProfileError == true
                );
            } else if (vm.currentWorkflow.value == 'details') {
                return (
                    !vm.license.server.name ||
                    (vm.license.server.description !== undefined &&
                        vm.license.server.description.length > 100) ||
                    !vm.license.server.countryCode
                );
            } else if (vm.currentWorkflow.value == 'subscription') {
                return (
                    vm.license.subscription.maxUsers == undefined ||
                    vm.license.subscription.maxUsers <= 0 ||
                    vm.license.subscription.maxDevices == undefined ||
                    vm.license.subscription.maxUsers >
                        vm.summary.subscription.premiumUserId.total -
                            vm.summary.subscription.premiumUserId.usage ||
                    vm.license.subscription.maxDevices >
                        vm.summary.subscription.deviceId.total -
                            vm.summary.subscription.deviceId.usage
                );
            } else if (
                vm.currentWorkflow.value == 'perpetual' &&
                vm.summary.subscription.premiumUserId.total == 0 &&
                vm.summary.perpetual.premiumUserId.total > 0
            ) {
                // Perpetual Only
                return (
                    vm.license.perpetual.maxUsers == undefined ||
                    (vm.summary.type == 'legacy' &&
                        vm.license.perpetual.maxUsers <= 0) ||
                    vm.license.perpetual.maxDevices == undefined ||
                    vm.license.perpetual.maxUsers >
                        vm.summary.perpetual.premiumUserId.total -
                            vm.summary.perpetual.premiumUserId.usage ||
                    vm.license.perpetual.maxDevices >
                        vm.summary.perpetual.deviceId.total -
                            vm.summary.perpetual.deviceId.usage
                );
            } else if (vm.currentWorkflow.value == 'perpetual') {
                // Subscription with perpetual
                return (
                    vm.license.perpetual.maxUsers == undefined ||
                    vm.license.perpetual.maxDevices == undefined ||
                    vm.license.perpetual.maxUsers >
                        vm.summary.perpetual.premiumUserId.total -
                            vm.summary.perpetual.premiumUserId.usage ||
                    vm.license.perpetual.maxDevices >
                        vm.summary.perpetual.deviceId.total -
                            vm.summary.perpetual.deviceId.usage
                );
            }
            return false;
        }
    };

    vm.next = function() {
        if (vm.currentWorkflow.value == 'server') {
            LicenseManagementService.decodeServerProfile(
                vm.license.server.payload
            ).then(
                function(data) {
                    vm.license.server.name = data.name;
                    vm.license.server.profiles = data.serverProfile;
                    vm.currentWorkflow =
                        vm.navs[vm.navs.indexOf(vm.currentWorkflow) + 1];
                },
                function() {
                    vm.license.serverProfileError = true;
                }
            );
        } else if (
            vm.currentWorkflow.value == 'details' ||
            vm.currentWorkflow.value == 'subscription' ||
            vm.currentWorkflow.value == 'perpetual'
        ) {
            var nextWorkflow = vm.navs[vm.navs.indexOf(vm.currentWorkflow) + 1];
            if (nextWorkflow.value == 'license') {
                if (!vm.processing) {
                    vm.processing = true;
                    LicenseManagementService.generateLicense(vm.license).then(
                        function(data) {
                            vm.license.payload = data;
                            vm.currentWorkflow = nextWorkflow;
                            $.each(vm.navs, function(index, value) {
                                value.disabled = true;
                                vm.processing = false;
                            });
                        },
                        function() {
                            vm.license.payload =
                                'Failed to generate license. Please try again. If the problem persists, please contact Appspace Support. ';
                            vm.license.hideButton = true;
                            vm.currentWorkflow = nextWorkflow;
                            $.each(vm.navs, function(index, value) {
                                value.disabled = true;
                                vm.processing = false;
                            });
                        }
                    );
                }
            } else {
                vm.currentWorkflow = nextWorkflow;
            }
        }
    };

    vm.back = function() {
        if (!vm.processing) {
            vm.currentWorkflow =
                vm.navs[vm.navs.indexOf(vm.currentWorkflow) - 1];
        }
    };

    vm.cancel = function() {
        vm.dismiss({ $value: 'cancel' });
    };

    vm.ok = function() {
        vm.close({ $value: 'close' });
        vm.avoidMultiClick = true;
    };

    function getNavigation() {
        var nav,
            navs = [];
        nav = {
            label: 'Server',
            value: 'server',
            resolve: {
                license: vm.license
            },
            component: 'licenseNewServer',
            callback: function(data) {
                vm.license.server.payload = data.payload;
                vm.license.eula = data.eula;
                vm.license.serverProfileError = data.serverProfileError; // send true of false value to check the validity of the server profile formatting
            }
        };
        navs.push(nav);
        nav = {
            label: 'Details',
            value: 'details',
            component: 'licenseNewServerDetails',
            resolve: {
                license: vm.license
            },
            bindings: {
                serverProfiles: 'license.server.profiles',
                licenseServerName: 'license.server.name',
                licenseServerDescription: 'license.server.description',
                licenseServerCountry: 'license.server.countryCode'
            },
            callback: function(data) {
                vm.license.server.name = data.name;
                vm.license.server.countryCode = data.countryCode;
                vm.license.server.description = data.description;
            }
        };
        navs.push(nav);
        if (vm.summary.subscription.premiumUserId.total > 0) {
            nav = {
                label: 'Subscription',
                value: 'subscription',
                component: 'licenseNewServerSubscription',
                resolve: {
                    summary: vm.summary.subscription,
                    license: vm.license.subscription
                },
                callback: function(data) {
                    vm.license.subscription.maxUsers = data.license.maxUsers;
                    vm.license.subscription.maxDevices =
                        data.license.maxDevices;
                }
            };
            navs.push(nav);
        }
        if (
            vm.summary.perpetual.premiumUserId.total -
                vm.summary.perpetual.premiumUserId.usage >
                0 ||
            (vm.summary.subscription.premiumUserId.total == 0 &&
                vm.summary.perpetual.premiumUserId.total > 0)
        ) {
            nav = {
                label: 'Perpetual',
                value: 'perpetual',
                component: 'licenseNewServerPerpetual',
                resolve: {
                    summary: vm.summary.perpetual,
                    license: vm.license.perpetual,
                    onlyPerpetual:
                        vm.summary.type == 'legacy' ||
                        vm.summary.subscription.premiumUserId.total == 0
                },
                callback: function(data) {
                    vm.license.perpetual.maxUsers = data.license.maxUsers;
                    vm.license.perpetual.maxDevices = data.license.maxDevices;
                }
            };
            navs.push(nav);
        }

        nav = {
            label: 'License',
            value: 'license',
            resolve: {
                license: vm.license
            },
            component: 'licenseManageLicense'
        };
        navs.push(nav);
        return navs;
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-register-new-instance/licenseRegisterNewInstance.component.js